import { Component, input, model, output } from '@angular/core';

@Component({
  selector: 'app-labelled-checkbox',
  templateUrl: './labelled-checkbox.component.html',
  styleUrl: './labelled-checkbox.component.scss',
})
export class LabelledCheckboxComponent {
  readonly label = input<string>('');
  checked = model<boolean>(false);
  changed = output<boolean>();
  disabled = input<boolean>(false);
  border = input<boolean>(true);

  toggleChecked() {
    this.checked.set(!this.checked());
    this.changed.emit(this.checked());
  }
}
